import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  Shield, 
  Mail, 
  Phone, 
  MapPin, 
  ExternalLink,
  Lock,
  AlertTriangle
} from 'lucide-react';
import logo from '../assets/icon.ico';


const Footer = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const quickLinks = [
    { name: "Cyber Security", href: "#services" },
    { name: "Digital Forensics", href: "#services" },
    { name: "Counter Intelligence", href: "#services" },
    { name: "Surveillance Systems", href: "#services" },
    { name: "Drone Operations", href: "#services" },
    { name: "Emergency Response", href: "#contact" }
  ];


  return (
    <footer className="bg-near-black relative overflow-hidden mt-10" ref={ref}>
      <div className="absolute inset-0 grid-pattern opacity-10" />
      <div className="container relative z-10 py-12 flex flex-col items-center text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="w-full flex flex-col items-center"
        >
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-36 h-36 rounded-12 flex items-center justify-center bg-white/10">
              <img src={logo} alt="CIARL" className="w-36 h-36" />
            </div>

          </div>
          <p className="text-gray-300 text-sm max-w-xl mb-4">
          <p className="text-gray-400 text-sm">Cyber Intelligence & Research Lab</p>
            Leaders in Digital Intelligence through Innovation
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4">
            <div className="flex items-center space-x-2">
              <Phone className="w-4 h-4 text-royal-gold" />
              <span className="text-gray-300 text-sm">+91 7506665502 (India)</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="w-4 h-4 text-royal-gold" />
              <span className="text-gray-300 text-sm">connect@ciarl.com</span>
            </div>
            <a
              href="https://www.google.com/maps?q=19.189456258027246,72.96748329708777"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 hover:text-royal-gold transition-colors duration-300"
            >
              <MapPin className="w-4 h-4 text-royal-gold" />
              <span className="text-gray-300 text-sm underline">Thane, Maharashtra</span>
            </a>
          </div>
        </motion.div>
        <div className="w-full border-t border-gray-700 mt-6 pt-6">
          <p className="text-gray-400 text-xs">© 2025 CIARL - Cyber Intelligence and Research Lab. All rights reserved.</p>
          <p className="text-gray-500 text-xs mt-2 mb-2 flex items-center justify-center"><Lock className="w-3 h-3 inline-block mr-1" /> This website uses encrypted communications. All sensitive information is protected according to government security standards and compliance requirements.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
